import {useState, useEffect} from 'react';
import axios from "../../utils/axios";

export default function useGetFeaturedMachines() {
  const [featured, setFeatured] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function fetchData() {
    try {
      setLoading(true);
      const response = await axios.get('/productos/productos_destacados');
      setFeatured(response.data.data.sort((a, b) => a.Orden_Destacado - b.Orden_Destacado))
      setLoading(false);
    } catch(err) {
      setLoading(false)
      setError(err)
      console.log(err)
    }
  }

  useEffect(() => {
    fetchData();
  }, [])
  return {featured, loading, error};
}
